import { ButtonColorConfig, ColorCombo } from './types';
import * as CSS from 'csstype';
import { colors } from '../../settings';

const defaultColorCombo: ButtonColorConfig = {
    normal: {
        backgroundColor: 'heritage',
        backgroundColorHover: 'heritageLight',
        backgroundColorActive: 'heritageDark',
        borderColor: 'heritage',
        borderColorHover: 'heritageLight',
        borderColorActive: 'heritageDark',
        textColor: 'bleachedAs',
        textColorHover: 'bleachedAs',
        textColorActive: 'bleachedAs',
    },
    selected: {
        backgroundColor: 'puntRoad',
        backgroundColorHover: 'puntRoad',
        backgroundColorActive: 'puntRoadDark',
        borderColor: 'puntRoad',
        borderColorHover: 'puntRoad',
        borderColorActive: 'puntRoadDark',
        textColor: 'bleachedAs',
        textColorHover: 'bleachedAs',
        textColorActive: 'bleachedAs',
    },
    disabled: {
        backgroundColor: 't1000',
        backgroundColorHover: 't1000',
        backgroundColorActive: 't1000',
        borderColor: 't1000',
        borderColorHover: 't1000',
        borderColorActive: 't1000',
        textColor: 'pebbleBeach',
        textColorHover: 'pebbleBeach',
        textColorActive: 'pebbleBeach',
    },
};

export function createButtonColorConfig(
    overrides: Partial<{
        normal?: Partial<ColorCombo>;
        selected?: Partial<ColorCombo>;
        disabled?: Partial<ColorCombo>;
    }> = {
        selected: undefined,
        disabled: undefined,
        normal: undefined,
    }
): ButtonColorConfig {
    const { normal = {}, disabled = {}, selected = {} } = overrides;
    return {
        normal: { ...defaultColorCombo.normal, ...normal },
        selected: { ...defaultColorCombo.selected, ...selected },
        disabled: { ...defaultColorCombo.disabled, ...disabled },
    };
}

export function createButtonPrimaryColorConfig(params: {
    color: CSS.Property.Color | colors.Color;
    colorHover: CSS.Property.Color | colors.Color;
    colorActive: CSS.Property.Color | colors.Color;
}): ButtonColorConfig {
    const { color, colorHover, colorActive } = params;
    return createButtonColorConfig({
        normal: {
            backgroundColor: color,
            backgroundColorHover: colorHover,
            backgroundColorActive: colorActive,
            borderColor: color,
            borderColorHover: colorHover,
            borderColorActive: colorActive,
        },
    });
}

export function createButtonSecondaryColorConfig(): ButtonColorConfig {
    return createButtonColorConfig({
        normal: {
            backgroundColor: 't1000',
            backgroundColorHover: 't1000Light',
            backgroundColorActive: 't1000Dark',
            borderColor: 't1000',
            borderColorHover: 't1000Light',
            borderColorActive: 't1000Dark',
            textColor: 'puntRoad',
            textColorHover: 'puntRoad',
            textColorActive: 'puntRoad',
        },
    });
}

export function createButtonTertiaryColorConfig(params: {
    color: CSS.Property.Color | colors.Color;
    colorHover: CSS.Property.Color | colors.Color;
    colorActive: CSS.Property.Color | colors.Color;
}): ButtonColorConfig {
    const { color, colorHover, colorActive } = params;
    return createButtonColorConfig({
        normal: {
            backgroundColor: 'transparent',
            backgroundColorHover: 'transparent',
            backgroundColorActive: 'transparent',
            borderColor: color,
            borderColorHover: colorHover,
            borderColorActive: colorActive,
            textColor: color,
            textColorHover: colorHover,
            textColorActive: colorActive,
        },
        selected: {
            backgroundColor: 'transparent',
            backgroundColorHover: 'transparent',
            backgroundColorActive: 'transparent',
            borderColor: 'puntRoad',
            borderColorHover: 'puntRoad',
            borderColorActive: 'puntRoadDark',
            textColor: 'puntRoad',
            textColorHover: 'puntRoad',
            textColorActive: 'puntRoadDark',
        },
        disabled: {
            backgroundColor: 'transparent',
            backgroundColorHover: 'transparent',
            backgroundColorActive: 'transparent',
            borderColor: 'pebbleBeach',
            borderColorHover: 'pebbleBeach',
            borderColorActive: 'pebbleBeach',
            textColor: 'pebbleBeach',
            textColorHover: 'pebbleBeach',
            textColorActive: 'pebbleBeach',
        },
    });
}
